
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "prettify-json",
  props: {
    objectToPrettify: {
      type: Object as () => Record<string, unknown> | null,
      required: false,
      default: () => ({}),
    },
    nestedPrimitives: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const entries = computed(() => Object.entries(props.objectToPrettify ?? {}));

    return { entries };
  },
});
